import { IPackaging, Packaging } from 'interfaces/IPackaging'
import { Department } from 'enums/department'
import BaseAutocomplete from './baseAutocomplete'

export const PACKAGING_ID = 'Packaging ID'
export const PACKAGING_NAME = 'Packaging Name'

const headers = [
  {
    id: 'packagingId',
    numeric: false,
    disablePadding: true,
    label: 'Kode Kemasan',
    width: 'medium',
  },
  {
    id: 'packagingName',
    numeric: false,
    disablePadding: false,
    label: 'Nama Kemasan',
    width: 'medium',
  },
  {
    id: 'stock',
    numeric: false,
    disablePadding: false,
    label: 'Stok',
    width: 'small',
  },
]

export default function LoadPackagingAutocomplete(props: {
  name?: string
  onChange?: (packaging: IPackaging) => void
  onInputChange?: (packaging: string, reason: string) => void
  disabled?: boolean
  required?: boolean
  showInactive?: boolean
  getMatchedData?: (premixes: IPackaging[]) => void
  showDetailedTable?: boolean
  loadAll?: boolean
  department?: Department
  includeDetails?: boolean
}) {
  const { name, loadAll, department, includeDetails, onChange } = props

  let url = '/packaging/getPackaging'

  const handleChange = (packaging?: IPackaging | null) => {
    onChange?.(packaging ?? new Packaging({}))
  }

  const responseMapper = (packaging: IPackaging) => {
    return `${packaging.packagingId} - ${packaging.packagingName}`
  }

  const extraParams: any = {
    ...(department && { department }),
    ...(includeDetails && { includeDetails: 'true' }),
  }

  return (
    <BaseAutocomplete
      {...props}
      url={url}
      extraParams={extraParams}
      headers={headers}
      label="Kode Set Kemasan"
      loadAll={loadAll}
      name={name}
      responseMapper={responseMapper}
      loadBySearch={true}
      onChange={handleChange}
    />
  )
}
